import { useEffect } from "react";
import { TouchableOpacity, View, Text } from "react-native";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useDevice } from "../../../utils/hooks/useDevice";
import SvaraModal from "./SvaraModal";
import { BtnCloseModal } from "../../../assets";
import { myTablesRequest } from "../../../store/lobby/lobbyActions";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { analyticsEvents } from "../../../services/firebase/analytics-events.service";

type Nav = NativeStackNavigationProp<RootStackParamList>;
interface IProps {
  onClose: () => void;
  tournamentId: string;
}

function JoinTournamentModal({ onClose, tournamentId }: IProps) {
  const dispatch = useDispatch();
  analyticsEvents.trackTournamentRegister("join");
  useEffect(() => {
    dispatch(myTablesRequest());
  }, [dispatch]);

  const { isXs } = useDevice();

  const { navigate } = useNavigation<Nav>();

  const { t } = useTranslation();

  // const items = [
  //   {
  //     id: "svaragametable-6e811350-5e88-4bf4-a266-fdcf66f7f879",
  //     name: "Sofia 2",
  //     chips: 500,
  //     room_id: "gameroom-63ae8c74-6bdc-4c4e-96e2-0c811ac3404b",
  //   },
  // ];

  return (
    <SvaraModal
      visible
      onClose={onClose}
      closeIcon={BtnCloseModal}
      bigCloseButton
      bigCloseBtnStyles={{
        width: 42,
        height: 42,
        ...(isXs && { transform: [{ translateX: 11 }, { translateY: -10 }] }),
      }}
    >
      {/* Title */}
      <Text
        style={{
          color: "white",
          fontSize: 22,
          fontWeight: "700",
          textAlign: "center",
          marginBottom: 24,
          textTransform: "uppercase",
        }}
      >
        Tournament will start soon. Join it
      </Text>

      {/* Buttons */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: "100%",
          marginTop: 8,
        }}
      >
        {/* REFUSE */}
        <TouchableOpacity
          onPress={() => onClose()}
          style={{
            minWidth: 120,
            paddingVertical: 10,
            paddingHorizontal: 16,
            borderRadius: 24,
            borderWidth: 1,
            borderColor: "#ffffff77",
            alignItems: "center",
          }}
        >
          <Text style={{ color: "#ffffffdd", fontSize: 16, fontWeight: "600" }}>
            Refuse
          </Text>
        </TouchableOpacity>

        {/* ACCEPT */}
        <TouchableOpacity
          onPress={() => {
            onClose();
            navigate("Game", { tableId: tournamentId, isTournamentRoom: true });
          }}
          style={{
            minWidth: 120,
            paddingVertical: 10,
            paddingHorizontal: 16,
            borderRadius: 24,
            backgroundColor: "#F0B223",
            alignItems: "center",
          }}
        >
          <Text style={{ color: "#1b0f09", fontSize: 16, fontWeight: "700" }}>
            Accept
          </Text>
        </TouchableOpacity>
      </View>
    </SvaraModal>
  );
}

export default JoinTournamentModal;
